import { StatusBadge } from "@/components/layout-2/ds";
import type { BadgeValue } from "@/types/dynamic-detail";

/** Version number and its status, whose `{label, tone}` the backend serves as `status_badge`. */
export function VersionBadge({ version, statusBadge }: { version: number; statusBadge?: BadgeValue | null }) {
    return (
        <span className="flex items-center gap-1.5">
            <span className="font-mono text-sm font-semibold">v{version}</span>
            <StatusBadge value={statusBadge} />
        </span>
    );
}
